/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface TopChannel
 */
export interface TopChannel {
    /**
     * 
     * @type {string}
     * @memberof TopChannel
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof TopChannel
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    pnoNet?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    pnoGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    profitNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    profitGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    profitPercentNet?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    profitPercentGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    spendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    spendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof TopChannel
     */
    turnoverGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    ordersNet?: number;
    /**
     * 
     * @type {number}
     * @memberof TopChannel
     */
    ordersGross?: number;
}

/**
 * Check if a given object implements the TopChannel interface.
 */
export function instanceOfTopChannel(value: object): value is TopChannel {
    return true;
}

export function TopChannelFromJSON(json: any): TopChannel {
    return TopChannelFromJSONTyped(json, false);
}

export function TopChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'name': json['name'] == null ? undefined : json['name'],
        'pnoNet': json['pnoNet'] == null ? undefined : json['pnoNet'],
        'pnoGross': json['pnoGross'] == null ? undefined : json['pnoGross'],
        'profitNet': json['profitNet'] == null ? undefined : MoneyOutputFromJSON(json['profitNet']),
        'profitGross': json['profitGross'] == null ? undefined : MoneyOutputFromJSON(json['profitGross']),
        'profitPercentNet': json['profitPercentNet'] == null ? undefined : json['profitPercentNet'],
        'profitPercentGross': json['profitPercentGross'] == null ? undefined : json['profitPercentGross'],
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsGross']),
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
        'ordersNet': json['ordersNet'] == null ? undefined : json['ordersNet'],
        'ordersGross': json['ordersGross'] == null ? undefined : json['ordersGross'],
    };
}

export function TopChannelToJSON(json: any): TopChannel {
    return TopChannelToJSONTyped(json, false);
}

export function TopChannelToJSONTyped(value?: TopChannel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'name': value['name'],
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'profitNet': MoneyOutputToJSON(value['profitNet']),
        'profitGross': MoneyOutputToJSON(value['profitGross']),
        'profitPercentNet': value['profitPercentNet'],
        'profitPercentGross': value['profitPercentGross'],
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'spendGoodsNet': MoneyOutputToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyOutputToJSON(value['spendGoodsGross']),
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
        'ordersNet': value['ordersNet'],
        'ordersGross': value['ordersGross'],
    };
}

